import { ApiRequest, BaseResource, patchItem, deleteItem, postItem, putItem } from "utils/ApiUtils";
import buildQuery from 'odata-query';
import ODataUtil from './ODataUtil';
import { IdrResource, Resource } from 'classes';

const resourceAssignment_endpoint = "/ResourceAssignment";

async function getResources(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const model = Resource;
  const endpoint = resourceAssignment_endpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, {model, endpoint});
  return data;
};

async function getAllResources(projectId,page, per_page, orderByInfo, orderByDirection, search) {
  console.log(projectId)
  const filters = [ 
    {"defaults" : {"IsActive": true, projectId: projectId}  
   }
   ]
  const model = Resource;
  const endpoint = resourceAssignment_endpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, {model, endpoint});
  return data;
};

async function getIDRResources(page, per_page, orderByInfo, orderByDirection, search, filters) {
  const workitem_endpoint = "/IrConfig";
  const model = IdrResource;
  const endpoint = workitem_endpoint;
  const data = await ODataUtil.gridQuery(page, per_page, orderByInfo, orderByDirection, search, filters, {model, endpoint});
  return data;
};

async function updateSettings(RassignmentId, data) {
  const resourcePath = `${resourceAssignment_endpoint}/Update`;

  const params = `?RassignmentId=${RassignmentId}`;
  //TODO:
  const result = await patchItem(resourcePath, params, data);
  return result;
};

async function addResource(data) {
  const resourcePath = `${resourceAssignment_endpoint}/Add`;
  const res = await postItem(resourcePath, '', data);
  return res;
}

async function deleteResource(projectId, { RassignmentId }) {
  const resourcePath = `${resourceAssignment_endpoint}/Delete`;
  const params = `?RassignmentId=${RassignmentId}`;
  const result = await deleteItem(resourcePath, params);
  return result;
}

class ReportAssignment extends BaseResource {
  constructor(args) {
    super(args, ReportAssignment.attributes)
  }

  static columns = [
    { title: "Resource Name", field: "Name_SystemUser", type: "string" },
    { title: "Email Address", field: "Email_SystemUser", type: "string" },
    // { title: "Select", field: "QcReqYn" }
  ]

  static attributes = ReportAssignment.columns.map(r => r.field);

  static expand = {
    OwnerRassignment: {
      expand: {
        SystemUser: {
          select: ["Name", "Email"]
        }
      },
      select: ["ProjectId"]
    }
  }
}

/**
 * Recipients for reports assignments.
 * Outputs from getReportAssingments, and is the input param to assignReport.
 */
class ReportRecipient extends BaseResource {
  constructor(args) {
    super(args, ReportRecipient.attributes);
  }

  static columns = [
    { title: "name", field: "name", type: "string" },
    { title: "email", field: "email", type: "string" },
    { title: "value", field: "value", type: "bool" },
    { title: "contactId", field: "contactId", type: "guid" },
    { title: "rAssignmentId", field: "rAssignmentId", type: "guid" }
  ]

  static attributes = ReportRecipient.columns.map(r => r.field);
}

/**
 * gets all report assignments for a specific project. Not currently used in the app.
 * @param { guid } projectId 
 */
async function getReportAssignments(projectId) {
  const endpoint = '/ReportAssignment';
  const { skip, count, top, expand, orderBy } = ODataUtil.UtilityBuilderNestedv3(
    25, 0, ReportAssignment.expand, undefined, undefined, undefined
  );
  const params = buildQuery({ count, top, skip, orderBy, expand, filter: {"OwnerRassignment": {"ProjectId": { eq: { type: 'guid', value: projectId } }} } });
  const data = await ApiRequest(endpoint, params);
  return data;
};

/**
 * gets possible recipients for a specific resource assignment.
 * @param { guid } rAssignmentId 
 */
async function getReportAssignmentRecips(rAssignmentId) {
  const endpoint = '/ReportAssignment/Recipients/Find';
  const params = `?rAssignmentId=${rAssignmentId}`;
  const data = await ApiRequest(endpoint, params);
  if (data.success) {
    return {
      success: true,
      data: data.data.map(r => new ReportRecipient(r))
    }
  } else {
    return { success: false }
  }
};

/**
 * PUTS recipient to update IDR routing value
 * @param { guid } parentRAssignmentId
 * @param { ReportRecipient } recipient 
 */
async function assignReport(parentRAssignmentId, recipient) {
  const endpoint = '/ReportAssignment/Recipients/Update';
  const params = `?rAssignmentId=${parentRAssignmentId}`;
  
  // translate from type ReportRecipient to the api payload scheme.
  const body = {
    Name: recipient.name,
    Email: recipient.email,
    Value: recipient.value,
    ContactId: recipient.contactId,
    RAssignmentId: recipient.rAssignmentId
  }

  // endpoint can't accept null values in keys, thus we remove those keys before sending
  Object.entries(body).forEach(([key, value], index) => {
    if( value === null || value === null) {
      delete body[key];
    }
  });

  const req = await putItem(endpoint, params, body);
  return req;
}

export {
  getResources, getIDRResources, updateSettings,deleteResource,
  addResource, ReportAssignment, getReportAssignments, getReportAssignmentRecips,
  assignReport,getAllResources
};